<p *ngIf="message">
  <ng-container *ngIf="errorCode">
    {{ errorCode | translate }}
  </ng-container>
  <ng-container *ngIf="!errorCode">
    {{ message | translate }}
  </ng-container>
</p>
